export default __webpack_public_path__ + "static/media/Mortiferous Chestguard.9a99eef4.jpg";